<template>
  <div class="success">
    <img class="success-icon" src="@/assets/icon/tip.svg" alt="">
    <span class="success-title">{{ $t('success.title') }}</span>
    <div class="success-msg">
      <span class="msg">{{ $t('success.message') }}</span>
    </div>
    <div class="success-btn" @click="closePage">{{ $t('success.closeBtn') }}</div>
  </div>
</template>

<script>
  export default {
  name: 'Success',
  methods: {
    closePage() {
      if (typeof WeixinJSBridge !== 'undefined') {
        window.WeixinJSBridge.call('closeWindow')
      } else if (typeof AlipayJSBridge !== 'undefined') {
        window.AlipayJSBridge.call('closeWebview')
      } else {
        window.close()
      }
    }
  }
}
</script>

<style lang="css" scoped>
.success {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.success-icon {
  padding-top: 3.25rem;
  width: 3.5rem;
  height: 2.1875rem;
}

.success-title {
  padding-top: 1.0625rem;
  font-size: 0.625rem;
  font-weight: 600;
  color: #242526;
}

.success-msg {
  width: 75%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 0.5rem;
  color: #999;
  word-wrap: break-word;
}

.success-msg .msg {
  font-size: 0.4rem;
}

.success-btn {
  margin-top: 1.5rem;
  padding: 0.4rem 1.2rem;
  font-size: 0.5rem;
  color: #fff;
  background: #07c160;
  border-radius: 0.25rem;
  cursor: pointer;
}
</style>
